import {
    type OrderEntityOrderItemsItem,
    type OrderListingEntityOrderItemsItem,
    type OrderItemVasLogisticsServiceEntity,
    type OrderItemVasProvisionalLicensePlateEntity,
    type OrderItemVasVehicleNationalizationEntity,
    type OrderItemVasVehicleRegistrationEntity,
    type OrderItemVasPowertrainWarrantyEntity,
    OrderItemKind,
    type OrderItemListingAuctionEntity,
    type OrderItemListingDealerSaleEntity,
    type OrderItemListingDirectSaleEntity,
    type OrderItemListingOfflineSaleEntity,
    type OrderItemAuctionEntity,
    type OrderItemDealerSaleEntity,
    type OrderItemDirectSaleEntity,
    type OrderItemOfflineSaleEntity,
} from '~/apiClient';

export function isSaleOrderItemEntity(
    orderItem: OrderEntityOrderItemsItem
): orderItem is OrderItemAuctionEntity | OrderItemDirectSaleEntity | OrderItemOfflineSaleEntity | OrderItemDealerSaleEntity {
    return orderItem.kind === OrderItemKind.Sale;
}

export function isSaleOrderListingItemEntity(
    orderItem: OrderListingEntityOrderItemsItem
): orderItem is
    | OrderItemListingAuctionEntity
    | OrderItemListingDirectSaleEntity
    | OrderItemListingOfflineSaleEntity
    | OrderItemListingDealerSaleEntity {
    return orderItem.kind === OrderItemKind.Sale;
}

type VasOrderItemEntity =
    | OrderItemVasLogisticsServiceEntity
    | OrderItemVasProvisionalLicensePlateEntity
    | OrderItemVasVehicleNationalizationEntity
    | OrderItemVasVehicleRegistrationEntity
    | OrderItemVasPowertrainWarrantyEntity;

export function isVasOrderItemEntity(orderItem: OrderEntityOrderItemsItem): orderItem is VasOrderItemEntity {
    return orderItem.kind === OrderItemKind.VAS;
}
